import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const productQuantity = [
  {
    name: 'NO_LIMIT',
    title: 'ไม่กำหนด'
  },
  {
    name: 'UNIT_10',
    title: '> 10 กก.'
  },
  {
    name: 'UNIT_100',
    title: '> 100 กก.'
  },
  {
    name: 'UNIT_1000',
    title: '> 1000 กก.'
  }
]

export const DialogQuantity = ({ data, open, onSubmit, onClose }) => {
  const [value, setValue] = useState(data)

  useEffect(() => {
    setValue(data)
  }, [data])

  const handleSubmit = value => {
    onSubmit(value)
    onClose()
  }
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      keepMounted
    >
      <DialogTitle id="confirmation-dialog-title">
        เลือกจำนวนขั้นต่ำ
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          name="ringtone"
          value={value}
          onChange={e => setValue(e.target.value)}
        >
          {productQuantity.map((option, index) => (
            <FormControlLabel
              key={`activity-option-${index.toString()}`}
              value={option.name}
              control={<Radio />}
              label={option.title}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => handleSubmit(value)}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DialogQuantity.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default DialogQuantity



// WEBPACK FOOTER //
// ./src/components/DialogQuantity/index.js